/* eslint-disable react/no-array-index-key */
/* eslint-disable dot-notation */
/* eslint-disable no-underscore-dangle */
/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import moment from 'moment';
import * as queryString from 'query-string';
import Textarea from 'react-textarea-autosize';
import { Scrollbars } from 'react-custom-scrollbars';
import PropTypes, { any } from 'prop-types';

import AdWrapper from '../../components/Ads/AdWrapper';
import PlayerSearch from '../../components/Form/PlayerSearch';
import InboxWelcomePopUp from '../../components/PopUps/WelcomePopUps/InboxWelcomePopUp';
import { postComponentAction } from '../../api/componentConfigApi';
import PopOverMenu from '../../components/PopOverMenu';
import Message from './Message';
import ReportPopup from './ReportPopup';
import MessageContainer from './MessageContainer';

import * as actions from '../../actions/messaging-actions';
import { fetchComponentConfig } from '../../actions/component-config-actions';
import { convHasUnreadMessages, ConversationContextTypes, MemberContextTypes, getMemberEntityObject } from '../../utils/messaging';
import { showSplash, hideSplash } from '../../actions/splash-actions';
import { ConfirmActionPopup } from '../../components/PopUps';
import { getApiAxiosInstance } from '../../utils/network';
import { getDisplayName } from '../../utils/members';

import config from '../../../config';
import styles from './styles.scss';
import { AdTypes } from '../../utils/types';
import { findBlockedEntity, getSelectedConversationData, getOtherUserForUnblock } from './inboxUtils';

export class InboxPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mobileState: 'list',
            conversationId: null,
            lastActivity: moment(),
            isPolling: false,
            showWelcomePopup: true,
        };

        this.selectConv = this.selectConv.bind(this);
        this.addRecepient = this.addRecepient.bind(this);
        this.removeRecepient = this.removeRecepient.bind(this);
        this.startConversation = this.startConversation.bind(this);
        this.onMessageChange = this.onMessageChange.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.keydownHandler = this.keydownHandler.bind(this);
        this.backToList = this.backToList.bind(this);
        this.startMessagePoll = this.startMessagePoll.bind(this);
        this.stopMessagePoll = this.stopMessagePoll.bind(this);
        this.restartMessagePoll = debounce(this.restartMessagePoll.bind(this), 500);
        this.handleConvPopoverClick = this.handleConvPopoverClick.bind(this);
        this.closeReportPopup = this.closeReportPopup.bind(this);
        this.sendReport = this.sendReport.bind(this);
        this.pollMessages = this.pollMessages.bind(this);
        this.closeBlockEntityConfirmationPopup = this.closeBlockEntityConfirmationPopup.bind(this);
        this.blockEntityConfirmation = this.blockEntityConfirmation.bind(this);
        this.getConversationBlockOptions = this.getConversationBlockOptions.bind(this);
        this.showUnblockEntityPopup = this.showUnblockEntityPopup.bind(this);
        this.closeUnblockEntityConfirmationPopup = this.closeUnblockEntityConfirmationPopup.bind(this);
        this.unblockEntityConfirmation = this.unblockEntityConfirmation.bind(this);
        this.getDisplayUnblock = this.getDisplayUnblock.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (!this.props.messaging.convs.length && this.props.auth.user) {
            this.props.showSplash({
                splash: 'load',
                title: 'Loading',
                description: 'Please wait while we\'re loading your messages...',
            });
            this.props.getConvs({ userId: this.props.auth.user.id });
            this.props.hideSplash();
        }
        this.props.fetchComponentConfig('inbox');
    }

    componentDidMount() {
        const { conversationId } = this.props.match.params;

        // Deep-link to start a new conversation with a recipient, e.g. the message
        // icons on club/event/player profiles push `/inbox?rid=<memberId>&rname=<name>`.
        // query-string already percent-decodes, so `rname` is the human-readable name.
        const { rid, rname } = queryString.parse(this.props.location?.search || '');
        const startingNewConversation = Boolean(rid && rname);
        if (startingNewConversation) {
            this.props.setNewConv(true);
            this.props.addRecepient({
                member: {
                    memberId: rid,
                    displayName: rname,
                },
            });
        }

        this.setState({
            conversationId,
            mobileState: startingNewConversation || this.props.messaging.recepients.length > 0 ? 'chat' : 'list',
        });
        document.addEventListener('keydown', this.keydownHandler);
        this.props.inboxIsOpen(true);

        this.props.getBlockedEntities({ userId: this.props.auth.user.id });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // Restore the draft into the composer if the send just failed for any reason
        // (server-side moderation rejection, network error, 5xx, etc.) and the user
        // hasn't started typing a replacement.
        if (
            !this.props.messaging.sendMessageFailed &&
            nextProps.messaging.sendMessageFailed &&
            this.pendingSendDraft &&
            this.state.message === ''
        ) {
            this.setState({ message: this.pendingSendDraft });
        }

        // first load
        if (this.state.timer === undefined) {
            if (nextProps.messaging.pollingInterval !== config.messaging.pollingIntervalMin) {
                this.props.setPollingInterval(config.messaging.pollingIntervalMin);
            }
            this.startMessagePoll(config.messaging.pollingIntervalMin);
            // cleared interval
        } else if (this.state.timer === null && nextProps.messaging.convs.length && !nextProps.messaging.newConversation && nextProps.messaging.selectedConv) {
            this.startMessagePoll(nextProps.messaging.pollingInterval);
            // ongoing polling
        } else if (this.state.timer && this.state.isPolling && nextProps.messaging.selectedConv !== this.props.messaging.selectedConv) {
            this.startMessagePoll(config.messaging.pollingIntervalMin);
        } else {
            // no polling state change needed
        }
    }

    componentDidUpdate() {
        const { messaging } = this.props;
        if (messaging?.convs?.length && !!this.state.conversationId) {
            const conv = messaging.convs.find(c => c.id === this.state.conversationId);
            if (conv) {
                this.selectConv(this.state.conversationId);
            }
            // Safe: guarded by conversationId being non-null, and immediately set to null,
            // so this only triggers once per deep-link navigation.
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ conversationId: null });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keydownHandler);
        // clear polling interval
        this.stopMessagePoll();
        this.props.setPollingInterval(config.messaging.pollingIntervalMax);
        this.props.clearRecepients();
        this.props.clearPreFlightData();
        this.props.inboxIsOpen(false);
    }

    onMessageChange(e) {
        this.setState({
            message: e.target.value,
            lastActivity: moment(),
        });
        this.restartMessagePoll();
    }

    getConversationBlockOptions(conv) {
        const { messaging } = this.props;
        const conversationBlockOptions = [];
        const otherParticipantsInConversation = conv.participants.filter((participant) => {
            return parseInt(participant.entityId) !== parseInt(this.props.auth.user.id) && participant.entityType === 'member';
        });

        otherParticipantsInConversation.forEach((participant) => {
            if (messaging.blockedEntities?.length > 0) {
                const blockedEntity = findBlockedEntity(messaging.blockedEntities, participant);

                if (!blockedEntity) {
                    conversationBlockOptions.push({ value: 'block', label: `Block ${getDisplayName(participant)}`, entityId: participant.entityId, entityType: participant.entityType });
                }
            } else {
                conversationBlockOptions.push({ value: 'block', label: `Block ${getDisplayName(participant)}`, entityId: participant.entityId, entityType: participant.entityType });
            }
        });
        return conversationBlockOptions;
    }

    getDisplayUnblock(selectedConv, convsWithBlockedEntities) {
        const { messaging } = this.props;
        const selectedConvContainsBlockedEntities = convsWithBlockedEntities.find((conv) => {
            return conv.id === selectedConv.id;
        });
        let displayUnblock = false;

        if (selectedConv?.participants) {
            displayUnblock = (selectedConv.participants.length === 2 && selectedConvContainsBlockedEntities);
        } else if (messaging.recepients?.length > 0 && messaging.blockedEntities?.length > 0) {
            displayUnblock = !!(messaging.recepients.find((recipient) => {
                return findBlockedEntity(messaging.blockedEntities, {
                    entityId: recipient.memberId,
                    entityType: 'member',
                });
            }));
        } else {
            // no blocked entities to check
        }

        return displayUnblock;
    }

    getRenderData() {
        const { messaging, auth } = this.props;
        const { selectedConv, peoplesDict, title, subtitle } = getSelectedConversationData(messaging, auth.user.id);

        let conversationOptions = [
            { value: 'report', label: 'Report Conversation' },
            { value: 'archive', label: 'Archive Conversation' },
            { value: 'delete', label: 'Delete Conversation' },
        ];

        const convsWithoutBlockedEntities = messaging?.convs?.length ? messaging.convs.filter((conv) => {
            return !conv?.participants?.find((participant) => findBlockedEntity(messaging.blockedEntities, participant));
        }) : [];
        const convsWithBlockedEntities = messaging?.convs?.length ? messaging.convs.filter(conv => !convsWithoutBlockedEntities.includes(conv)) : [];

        let displayUnblock = false;
        if (selectedConv) {
            conversationOptions = conversationOptions.concat(this.getConversationBlockOptions(selectedConv));
            displayUnblock = this.getDisplayUnblock(selectedConv, convsWithBlockedEntities);
        }

        const isButtonDisabled = !(messaging?.recepients?.length || (selectedConv?.messages?.length)) || !this.state.message?.length;
        const showSelectedConvMessages = selectedConv?.messages?.length && selectedConv?.participants?.length && !messaging?.newConversation;

        return { selectedConv, peoplesDict, title, subtitle, conversationOptions, convsWithoutBlockedEntities, convsWithBlockedEntities, displayUnblock, isButtonDisabled, showSelectedConvMessages };
    }

    addRecepient(member) {
        if (member) {
            this.props.clearPreFlightData();
            this.props.addRecepient({ member });
        }
    }

    backToList() {
        this.props.setNewConv(false);
        this.setState({
            mobileState: 'list',
            lastActivity: moment(),
        });
        this.restartMessagePoll();
    }

    blockEntityConfirmation(ev, currentEntityToBlock) {
        this.props.blockEntity({
            userId: this.props.auth.user.id,
            blockEntityRequest: {
                entityId: currentEntityToBlock.entityId,
                entityType: currentEntityToBlock.entityType,
            },
        });

        this.closeBlockEntityConfirmationPopup();
    }

    closeBlockEntityConfirmationPopup() {
        this.setState({
            showBlockEntityConfirmationPopup: false,
            currentEntityToBlock: null,
        });
    }

    closeReportPopup() {
        this.setState({
            showReportPopup: false,
        });
    }

    closeUnblockEntityConfirmationPopup() {
        this.setState({
            showUnblockEntityConfirmationPopup: false,
            currentEntityToUnblock: null,
        });
    }

    handleConvPopoverClick(e) {
        switch (e.value) {
            case 'report':
                this.props.newReport();
                this.setState({
                    showReportPopup: true,
                });
                break;
            case 'archive':
                this.props.archiveConv({
                    userId: this.props.auth.user.id,
                    convId: this.props.messaging.selectedConv,
                });
                break;
            case 'delete':
                this.props.deleteConv({
                    userId: this.props.auth.user.id,
                    convId: this.props.messaging.selectedConv,
                });
                this.backToList();
                break;
            case 'block': {
                const selectedConv = this.props.messaging.convs.find(conv => conv.id == this.props.messaging.selectedConv);
                const currentParticipantToBlock = selectedConv.participants.find((participant) => {
                    return parseInt(participant.entityId) === parseInt(e.entityId) && participant.entityType === e.entityType;
                });

                if (currentParticipantToBlock) {
                    this.setState({
                        showBlockEntityConfirmationPopup: true,
                        currentEntityToBlock: {
                            entityId: currentParticipantToBlock.entityId,
                            entityType: currentParticipantToBlock.entityType,
                            displayName: getDisplayName(currentParticipantToBlock),
                        },
                    });
                }
                break;
            }
            default:
                break;
        }
    }

    keydownHandler(e) {
        if (e.keyCode === 13 && e.ctrlKey) {
            this.sendMessage();
        }
    }

    pollMessages() {
        const { messaging } = this.props;
        const selectedConv = messaging.convs.find(conv => conv.id == messaging.selectedConv);

        if (!selectedConv?.participants?.length) {
            return;
        }

        this.props.getMessages({
            userId: this.props.auth.user.id,
            convId: selectedConv.id,
            after: selectedConv?.messages?.length > 0 ? selectedConv.messages[0].created : null,
            polling: true,
        });

        if (this.state.lastActivity?._isAMomentObject) {
            const diff = moment().diff(this.state.lastActivity, 'seconds');

            if ((!messaging.pollingInterval || messaging.pollingInterval < config.messaging.pollingIntervalMax) && diff > 20) {
                this.restartMessagePoll(config.messaging.pollingIntervalMax);
            }
        }
    }

    removeRecepient(index) {
        this.props.removeRecepient({ index });
        this.props.clearPreFlightData();
    }

    restartMessagePoll(interval) {
        this.stopMessagePoll(() => {
            this.props.setPollingInterval(interval || config.messaging.pollingIntervalMin);
            // restart of polling happens in componentWillReceiveProps
        });
    }

    selectConv(convId) {
        this.setState({
            mobileState: 'chat',
            lastActivity: moment(),
        });
        this.props.selectConv({
            userId: this.props.auth.user.id,
            convId,
        });
        // restart of polling happens in componentWillReceiveProps
    }

    sendMessage() {
        const { coreUI, messaging, auth } = this.props;

        if (this.props.messaging.newConversation && this.state.message?.trim().length) {
            let conversation;
            if (messaging.preflightConvData) {
                conversation = messaging.preflightConvData;
            } else {
                conversation = {
                    entities: [],
                };
                conversation.originatingContext = coreUI.types.messagingConversationContextType.find(t => t.id === ConversationContextTypes.INBOX).value;
                conversation.entities.push(getMemberEntityObject(coreUI.types, auth.user.id, MemberContextTypes.PLAYER));
                this.props.messaging.recepients.forEach((reciepient) => {
                    conversation.entities.push(getMemberEntityObject(coreUI.types, reciepient.memberId, MemberContextTypes.PLAYER));
                });
            }
            conversation.message = {
                content: this.state.message,
            };
            this.pendingSendDraft = this.state.message;
            this.props.startConv({ userId: auth.user.id, conv: conversation });
            this.setState({
                message: '',
            });
        } else if (this.props.messaging.selectedConv && this.state.message?.trim().length) {
            this.pendingSendDraft = this.state.message;
            this.props.sendMessage({
                userId: this.props.auth.user.id,
                convId: this.props.messaging.selectedConv,
                message: {
                    content: this.state.message,
                },
            });
            this.setState({
                message: '',
            });
        } else {
            this.setState({
                message: '',
            });
        }
    }

    sendReport(formValues) {
        this.props.sendReport({
            userId: this.props.auth.user.id,
            convId: this.props.messaging.selectedConv,
            values: formValues.values,
        });
    }

    showUnblockEntityPopup(participantToUnblock) {
        this.setState({
            showUnblockEntityConfirmationPopup: true,
            currentEntityToUnblock: {
                entityId: participantToUnblock.entityId,
                entityType: participantToUnblock.entityType,
                displayName: getDisplayName(participantToUnblock),
            },
        });
    }

    startConversation() {
        this.stopMessagePoll();
        this.props.clearPreFlightData();
        this.props.setNewConv(true);
        this.setState({
            mobileState: 'chat',
        });
    }

    startMessagePoll(interval) {
        const { messaging } = this.props;
        const startPolling = () => {
            if (messaging.convs.length && messaging.selectedConv) {
                this.setState({
                    timer: setInterval(this.pollMessages, interval || messaging.pollingInterval || 30000),
                    isPolling: true,
                });
            }
        };

        if (this.state.timer && this.state.isPolling) {
            this.stopMessagePoll();
            if (interval) {
                this.props.setPollingInterval(interval);
            }
        } else {
            startPolling();
        }
    }

    stopMessagePoll(cb) {
        if (this.state.timer) {
            clearInterval(this.state.timer);
        }
        this.setState({
            timer: null,
            isPolling: false,
        }, () => {
            if (cb) {
                cb();
            }
        });
    }

    unblockEntityConfirmation() {
        const { currentEntityToUnblock } = this.state;
        this.props.unblockEntity({
            userId: this.props.auth.user.id,
            unblockEntityRequest: {
                entityId: currentEntityToUnblock.entityId,
                entityType: currentEntityToUnblock.entityType,
            },
        });

        this.closeUnblockEntityConfirmationPopup();
    }

    renderWelcomePopup() {
        const { auth, componentConfig } = this.props;
        const isPowerUser = auth.user.isPowered;
        const compConfig = componentConfig['inbox'];
        const inboxWelcomePopupConfig = !!compConfig?.modals?.length && compConfig?.modals?.find(m => m.type === 'inbox_welcome_popup');

        if (!inboxWelcomePopupConfig) {
            return null;
        }

        const axiosInstance = getApiAxiosInstance();
        const dismissPopup = () => {
            this.setState({ showWelcomePopup: false });
            postComponentAction(axiosInstance, 'inbox', inboxWelcomePopupConfig.actions.dismissed.event, { properties: {} });
        };

        return (
            <InboxWelcomePopUp
                isPowerUser={isPowerUser}
                onPowerClick={this.props.showPowerPopup}
                onCloseClick={dismissPopup}
                onCtaClick={dismissPopup}
            />
        );
    }

    renderConversationList(convsWithoutBlockedEntities, convsWithBlockedEntities, selectedConv) {
        const { messaging, auth, 'data-testid': dataTestId } = this.props;

        if (!messaging?.convs?.length) {
            return (
                <>
                    {messaging?.pageLoadedOnce && (
                        <>
                            <div className="start-new-conv text-small text-uppercase" data-testid="inbox.start-new-conv">Start a new conversation <i className="utr utr-help-arrow" /></div>
                            <div className="mobile-welcome d-flex aic jcc d-md-none">
                                <div className="text-center">
                                    <p className="text-medium" data-testid="inbox.mobile-welcome-heading">Welcome to your messages!</p>
                                    <p className="mt16" data-testid="inbox.mobile-welcome-body">Message with organizers and players to better coordinate your activity on UTR Sports.</p>
                                    <p className="mt16" data-testid="inbox.mobile-welcome-instructions">To start a new conversation, click the <i className="utr utr-new-message fs24 p8" /> icon above or the message icons on club, event and player profile pages.</p>
                                    <p className="text-error mt16" data-testid="inbox.mobile-welcome-warning"><b>Warning:</b> UTR Sports reserves the right to disable your messaging and/or suspend your account if you spam or send inappropriate content to other users.</p>
                                </div>
                            </div>
                        </>
                    )}
                </>
            );
        }

        return (
            <>
                {convsWithoutBlockedEntities?.length > 0 && convsWithoutBlockedEntities.map((conv, i) => {
                    const otherUser = conv.participants.find(user => user.entityId != auth.user.id);
                    if (conv?.messages?.length) {
                        return (
                            <Message
                                id={conv.id}
                                type="conv"
                                className={`${selectedConv?.id == conv.id ? 'selected' : ''}`}
                                key={`conv${i}`}
                                handleClick={this.selectConv}
                                playerProfileImages={otherUser?.playerProfileImages}
                                name={conv.title}
                                message={conv.messages[0].isOutbound ? `You: ${conv.messages[0].fallback}` : conv.messages[0].fallback}
                                timestamp={conv.messages[0].created}
                                hasNewMessage={convHasUnreadMessages(conv) && (selectedConv?.id != conv.id)}
                                isPreview={true}
                                data-testid={dataTestId ? `${dataTestId}.conv-${conv.id}` : undefined}
                            />
                        );
                    }
                    return null;
                })}
                {convsWithBlockedEntities?.length > 0 && (
                    <>
                        {convsWithBlockedEntities.map((conv, i) => {
                            const otherUser = conv.participants.find(user => user.entityId != auth.user.id);
                            if (conv?.messages?.length) {
                                return (
                                    <Message
                                        id={conv.id}
                                        type="conv"
                                        className={`${selectedConv?.id == conv?.id ? 'selected' : ''}`}
                                        key={`conv${i}`}
                                        handleClick={this.selectConv}
                                        playerProfileImages={otherUser?.playerProfileImages}
                                        name={conv.title}
                                        message={conv.messages[0].isOutbound ? `You: ${conv.messages[0].fallback}` : conv.messages[0].fallback}
                                        timestamp={conv.messages[0].created}
                                        hasNewMessage={convHasUnreadMessages(conv) && (selectedConv && selectedConv.id != conv.id)}
                                        isPreview={true}
                                        showBlockedIcon={true}
                                        data-testid={dataTestId ? `${dataTestId}.blocked-conv-${conv.id}` : undefined}
                                    />
                                );
                            }
                            return null;
                        })}
                    </>
                )}
                <div />
            </>
        );
    }

    renderMessageArea(selectedConv, peoplesDict, showSelectedConvMessages, isButtonDisabled, displayUnblock) {
        const { messaging, auth, 'data-testid': dataTestId } = this.props;

        return (
            <>
                {messaging?.newConversation && (
                    <div className="add-people d-flex aic">
                        <div className="to" data-testid={dataTestId && `${dataTestId}.to-label`}>To:</div>
                        <div className="tag-container">
                            {messaging?.recepients?.map((recepient, i) => <div className="tag tag-grey-outline" key={`rec${i}`} data-testid={dataTestId && `${dataTestId}.recipient-tag-${i}`}>{getDisplayName(recepient)} <div className="close-wrapper" onClick={() => this.removeRecepient(i)} data-testid={dataTestId && `${dataTestId}.recipient-tag-${i}.remove-btn`}><i className="uts uts-close" /></div></div>)}
                        </div>
                        <div className="input-container">
                            {!messaging?.recepients?.length && (
                                <PlayerSearch
                                    className="inline-input"
                                    placeholder="Add recipient..."
                                    showInvitePlayer={false}
                                    handlePlayerSelect={this.addRecepient}
                                    clearAfterSelect={true}
                                    searchMembersOnly={true}
                                    searchParams={{ filter: [`memberId:!${auth.user.id}`, 'isPro:false'] }}
                                    autoFocus={true}
                                />
                            )}
                        </div>
                    </div>
                )}
                <div className={`messages-wrapper ${messaging?.pageLoadedOnce ? '' : 'd-flex aic jcc'}`}>
                    {messaging?.convs?.length ? (
                        <>
                            {showSelectedConvMessages ? (
                                <MessageContainer
                                    messages={selectedConv.messages}
                                    lastRead={selectedConv.lastRead}
                                    selectedConv={selectedConv}
                                    peoplesDict={peoplesDict}
                                    loading={messaging.isLoading}
                                    scrollToBottom={messaging.scrollToBottom}
                                    scrolledToBottom={this.props.scrolledToBottom}
                                    data-testid={dataTestId ? `${dataTestId}.message-container` : undefined}
                                />
                            ) : (
                                <>
                                    {!messaging?.newConversation && (
                                        <div className="text-center">
                                            <p className="text-medium"><i className="fas fa-circle-notch fa-spin" /></p>
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            {!messaging?.pageLoadedOnce ? (
                                <div className="text-center">
                                    <p className="text-medium"><i className="fas fa-circle-notch fa-spin" /></p>
                                </div>
                            ) : (
                                <>
                                    {messaging?.newConversation ? null : (
                                        <div className="text-center p48">
                                            <p className="text-medium" data-testid="inbox.desktop-welcome-heading">Welcome to your messages!</p>
                                            <p className="mt16" data-testid="inbox.desktop-welcome-body">Message with organizers and players to better coordinate your activity on UTR Sports.</p>
                                            <p className="mt16" data-testid="inbox.desktop-welcome-instructions">To start a new conversation, click the <i className="utr utr-new-message fs24 p8" /> icon above or the message icons on club, event and player profile pages.</p>
                                            <p className="text-error mt16" data-testid="inbox.desktop-welcome-warning"><b>Warning:</b> UTR Sports reserves the right to disable your messaging and/or suspend your account if you spam or send inappropriate content to other users.</p>
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
                {this.renderInputArea(selectedConv, isButtonDisabled, displayUnblock)}
            </>
        );
    }

    renderInputArea(selectedConv, isButtonDisabled, displayUnblock) {
        const { messaging, 'data-testid': dataTestId } = this.props;
        const showInput = messaging?.newConversation || (messaging?.convs?.length && selectedConv?.messages?.length && selectedConv?.participants?.length > 0);

        if (!showInput) {
            return null;
        }

        if (displayUnblock) {
            return (
                <div className="input-wrapper row">
                    <div className="col-9">
                        <div className="d-flex aic text-small" style={{ maxHeight: '107px', minHeight: '53px' }}>
                            You&apos;ve blocked this user. If you&apos;d like to send them a message, click &quot;Unblock&quot;.
                        </div>
                    </div>
                    <div className="col-3 d-flex aie">
                        <button
                            type="button"
                            className="btn btn-lg btn-primary btn-block"
                            style={{ height: '53px' }}
                            onClick={() => {
                                const otherUser = getOtherUserForUnblock(selectedConv, this.props.messaging, this.props.auth.user.id);
                                if (otherUser) {
                                    this.showUnblockEntityPopup(otherUser);
                                }
                            }}
                            data-testid={dataTestId ? `${dataTestId}.unblock-btn` : undefined}
                        >
                            Unblock
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="input-wrapper row">
                <div className="col-12 col-md-9">
                    <div className="textarea-wrapper">
                        <Textarea
                            className="form-control"
                            maxRows={3}
                            placeholder="Type a message..."
                            style={{ maxHeight: '107px', minHeight: '53px' }}
                            value={this.state.message}
                            onChange={this.onMessageChange}
                            data-testid={dataTestId ? `${dataTestId}.message-input` : undefined}
                        />
                        <button
                            type="button"
                            className="btn btn-primary send-button d-md-none"
                            disabled={isButtonDisabled}
                            onClick={this.sendMessage}
                            data-testid={dataTestId ? `${dataTestId}.send-btn-mobile` : undefined}
                        >
                            <i className="uts uts-next-full" />
                        </button>
                    </div>
                </div>
                <div className="col-3 d-none d-md-flex aie">
                    <button
                        type="button"
                        className={`btn btn-primary btn-block text-uppercase`}
                        disabled={isButtonDisabled}
                        onClick={this.sendMessage}
                        data-testid={dataTestId ? `${dataTestId}.send-btn` : undefined}
                    >
                        Send
                    </button>
                </div>
            </div>
        );
    }

    renderPopups() {
        const { 'data-testid': dataTestId } = this.props;
        return (
            <>
                {this.state.showReportPopup && (
                    <ReportPopup
                        onCloseClick={this.closeReportPopup}
                        onSendClick={this.sendReport}
                        reportPending={this.props.messaging?.reportPending}
                        reportSuccess={this.props.messaging?.reportSuccess}
                        reportError={this.props.messaging?.reportError}
                        data-testid={dataTestId ? `modal.${dataTestId}.report` : 'modal.inbox.report'}
                    />
                )}
                {this.state.showBlockEntityConfirmationPopup && this.state.currentEntityToBlock && (
                    <ConfirmActionPopup
                        onCloseClick={this.closeBlockEntityConfirmationPopup}
                        onCtaClick={this.blockEntityConfirmation}
                        confirmationTitle="Block User Confirmation"
                        confirmationMessage={`Are you sure you want to block ${getDisplayName(this.state.currentEntityToBlock)}? If so, please click "Confirm".`}
                        confirmationDataValue={this.state.currentEntityToBlock}
                    />
                )}
                {this.state.showUnblockEntityConfirmationPopup && this.state.currentEntityToUnblock && (
                    <ConfirmActionPopup
                        onCloseClick={this.closeUnblockEntityConfirmationPopup}
                        onCtaClick={this.unblockEntityConfirmation}
                        confirmationTitle="Unblock User Confirmation"
                        confirmationMessage={`Are you sure you want to unblock ${getDisplayName(this.state.currentEntityToUnblock)}? If so, please click "Confirm".`}
                        confirmationDataValue={this.state.currentEntityToUnblock}
                    />
                )}
                {this.state.showWelcomePopup && this.renderWelcomePopup()}
            </>
        );
    }

    renderAds(inboxConfig, isMobileWidth, isTabletWidth) {
        const showRectangles = inboxConfig?.showRectangle;

        if (!showRectangles) {
            return null;
        }

        const isMobile = isMobileWidth || isTabletWidth;

        return (
            <div className={`${styles.rectangleAdContainer} container`}>
                {!isMobile && (
                    <>
                        <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="inbox.ad.rectangle-1" />
                        <AdWrapper type={AdTypes.RECTANGLE_TWO} data-testid="inbox.ad.rectangle-2" />
                        <AdWrapper type={AdTypes.RECTANGLE_THREE} data-testid="inbox.ad.rectangle-3" />
                    </>
                )}
                {isMobile && (
                    <>
                        <AdWrapper type={AdTypes.RECTANGLE_ONE} data-testid="inbox.ad.mobile-rectangle-1" />
                        <div className={styles.bottomAd}>
                            <AdWrapper type={AdTypes.RECTANGLE_TWO} data-testid="inbox.ad.mobile-rectangle-2" />
                        </div>
                    </>
                )}
            </div>
        );
    }

    render() {
        if (!__CLIENT__) {
            return null;
        }

        const { messaging, showAds, inboxConfig, isMobileWidth, isTabletWidth, 'data-testid': dataTestId } = this.props;
        const { mobileState } = this.state;
        const { selectedConv, peoplesDict, title, subtitle, conversationOptions, convsWithoutBlockedEntities, convsWithBlockedEntities, displayUnblock, isButtonDisabled, showSelectedConvMessages } = this.getRenderData();

        const listVisibility = mobileState == 'list' ? 'd-block' : 'd-none';
        const chatVisibility = mobileState == 'chat' ? 'd-block' : 'd-none';
        const hasConvContent = messaging?.convs?.length && ((selectedConv?.messages?.length && selectedConv?.participants?.length) || messaging?.newConversation);
        const messagesClass = `messages ${hasConvContent ? '' : 'd-flex aic jcc'}`;
        const showPopoverMenu = !messaging?.newConversation && selectedConv;

        return (
            <div>
                {showAds && inboxConfig.showLeaderboard && (
                    <div className="d-flex jcc mt40 container">
                        <AdWrapper type={AdTypes.LEADERBOARD_ONE} data-testid="inbox.ad.leaderboard" />
                    </div>
                )}
                <div className={`${styles.inbox} container`} data-testid={dataTestId}>
                    <div className="row">
                        <div className={`col-12 col-md-4 ${listVisibility} d-md-block`}>
                            <div className="inbox-header d-flex br aic jsb">
                                <span className="text-medium" data-testid={dataTestId ? `${dataTestId}.messages-title` : undefined}>Messages</span>
                                <div className="click-area click-area-48 fs24 text-teal" onClick={this.startConversation} title="Start New Conversation" data-testid={dataTestId ? `${dataTestId}.new-conversation-btn` : undefined}>
                                    <i className="utr utr-new-message" />
                                </div>
                            </div>
                        </div>
                        <div className={`col-12 col-md-8 ${chatVisibility} d-md-block`}>
                            <div className="inbox-header inbox-title d-flex aic jcsb">
                                <div className="click-area click-area-48 fs16 d-md-none" onClick={this.backToList} data-testid={dataTestId ? `${dataTestId}.back-btn` : undefined}>
                                    <i className="uts uts-prev" />
                                </div>
                                <div className="d-none d-md-block">&nbsp;</div>
                                <div className="title-wrapper text-center">
                                    <div className="title" data-testid={dataTestId ? `${dataTestId}.chat-title` : undefined}>{title}</div>
                                    {selectedConv ? <div className="subtitle" data-testid={dataTestId ? `${dataTestId}.chat-subtitle` : undefined}>{subtitle}</div> : null}
                                </div>
                                {showPopoverMenu ? (
                                    <PopOverMenu
                                        popOverMenuClass=""
                                        menuItems={conversationOptions}
                                        onSelected={this.handleConvPopoverClick}
                                    >
                                        <div className="click-area click-area-48 fs16">
                                            <i className="uts uts-more" />
                                        </div>
                                    </PopOverMenu>
                                ) : <div>&nbsp;</div>}
                            </div>
                        </div>
                    </div>
                    <div className="row flex-1-1">
                        <div className={`col col-md-4 ${listVisibility} d-md-block`}>
                            <div className="conv-list">
                                <Scrollbars
                                    style={{ height: '100%' }}
                                    universal
                                >
                                    {this.renderConversationList(convsWithoutBlockedEntities, convsWithBlockedEntities, selectedConv)}
                                </Scrollbars>
                            </div>
                        </div>
                        <div className={`col col-md-8 ${chatVisibility} d-md-block`}>
                            <div className={messagesClass}>
                                {this.renderMessageArea(selectedConv, peoplesDict, showSelectedConvMessages, isButtonDisabled, displayUnblock)}
                            </div>
                        </div>
                    </div>
                    {this.renderPopups()}
                </div>
                {showAds && this.renderAds(inboxConfig, isMobileWidth, isTabletWidth)}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getConvs: async ({ userId }) => {
            await dispatch(actions.getConvs({ userId }));
        },
        getMessages: ({ userId, convId, after, before, polling }) => {
            dispatch(actions.getMessages({ userId, convId, after, before, polling }));
        },
        selectConv: ({ userId, convId }, cb) => {
            dispatch(actions.selectConv({ userId, convId }, cb));
        },
        startConv: ({ userId, conv }) => {
            dispatch(actions.startConv({ userId, conv }));
        },
        sendMessage: ({ userId, convId, message }) => {
            dispatch(actions.sendMessage({ userId, convId, message }));
        },
        setLastRead: ({ userId, convId }) => {
            dispatch(actions.setLastRead({ userId, convId }));
        },
        addRecepient: ({ member }) => {
            dispatch(actions.addRecepient({ member }));
        },
        clearPreFlightData: () => {
            dispatch(actions.clearPreFlightData());
        },
        removeRecepient: ({ index }) => {
            dispatch(actions.removeRecepient({ index }));
        },
        clearRecepients: () => {
            dispatch(actions.clearRecepients());
        },
        showPowerPopup: () => {
            dispatch(actions.showPowerPopup());
        },
        setNewConv: (bool) => {
            dispatch(actions.setNewConv(bool));
        },
        newReport: () => {
            dispatch(actions.newReport());
        },
        sendReport: ({ userId, convId, values }) => {
            dispatch(actions.sendReport({ userId, convId, values }));
        },
        scrolledToBottom: () => {
            dispatch(actions.scrolledToBottom());
        },
        inboxIsOpen: (bool) => {
            dispatch(actions.inboxIsOpen(bool));
        },
        setPollingInterval: (pollingInterval) => {
            dispatch(actions.setPollingInterval(pollingInterval));
        },
        fetchComponentConfig: (componentConfig) => {
            dispatch(fetchComponentConfig(componentConfig));
        },
        archiveConv: ({ userId, convId }) => {
            dispatch(actions.archiveConv({ userId, convId }));
        },
        deleteConv: ({ userId, convId }) => {
            dispatch(actions.deleteConv({ userId, convId }));
        },
        blockEntity: ({ userId, blockEntityRequest }) => {
            dispatch(actions.blockEntity({ userId, blockEntityRequest }));
        },
        getBlockedEntities: ({ userId }) => {
            dispatch(actions.getBlockedEntities({ userId }));
        },
        unblockEntity: ({ userId, unblockEntityRequest }) => {
            dispatch(actions.unblockEntity({ userId, unblockEntityRequest }));
        },
        showSplash: ({ splash, title, description }) => {
            dispatch(showSplash({ splash, title, description }));
        },
        hideSplash: () => dispatch(hideSplash()),
    };
}

function mapStateToProps({ auth, messaging, coreUI, componentConfig }) {
    return { auth, messaging, coreUI, componentConfig };
}

InboxPage.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.object,
    }).isRequired,
    coreUI: PropTypes.objectOf(any).isRequired,
    showAds: PropTypes.bool,
    inboxConfig: PropTypes.shape({
        showRectangle: PropTypes.bool,
        showLeaderboard: PropTypes.bool,
    }),
    isMobileWidth: PropTypes.bool,
    isTabletWidth: PropTypes.bool,
    messaging: PropTypes.shape({
        blockedEntities: PropTypes.arrayOf(PropTypes.object),
        convs: PropTypes.arrayOf(PropTypes.object),
        newConversation: PropTypes.bool,
        isLoading: PropTypes.bool,
        pageLoadedOnce: PropTypes.bool,
        scrollToBottom: PropTypes.bool,
        scrolledToBottom: PropTypes.bool,
        selectedConv: PropTypes.shape({
            participants: PropTypes.arrayOf(PropTypes.object),
            messages: PropTypes.arrayOf(PropTypes.object),
            id: PropTypes.string,
        }),
        showPaywallPopup: PropTypes.bool,
        recepients: PropTypes.arrayOf(PropTypes.object),
        reportPending: PropTypes.bool,
        reportSuccess: PropTypes.bool,
        reportError: PropTypes.bool,
    }).isRequired,
    componentConfig: PropTypes.shape({
        inbox: PropTypes.shape({
            modals: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string,
            })),
        }),
    }),
};

InboxPage.defaultProps = {
    showAds: false,
    inboxConfig: {
        showRectangle: false,
        showLeaderboard: false,
    },
    isMobileWidth: false,
    isTabletWidth: false,
    componentConfig: {
        inbox: {
            modals: [],
        },
    },
};
export default connect(mapStateToProps, mapDispatchToProps)(InboxPage);
